import React from 'react';
import { sendOnboardingForm } from '../hooks/mutations';
import toast from 'react-hot-toast';
import { JobApplication } from '../types/jobs';
import { BtnPrimary } from '../components/common/Buttons';
import { LoaderCircle } from 'lucide-react';

interface AgentOnboardProps {
  initialData: JobApplication;
  onError: (error: Error) => void;
  onSuccess?: (data: any) => void;
}

const AgentOnboard: React.FC<AgentOnboardProps> = ({
  initialData,
  onError,
  onSuccess,
}) => {
  const { mutate: sendForm, isPending: isSending } = sendOnboardingForm({
    onSuccess: (data) => {
      toast.success(data.message || 'Email sent successfully');
      onSuccess?.(data);
    },
    onError: (error) => {
      onError(error);
    },
  });

  const handleSendEmail = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    sendForm({
      applicationId: initialData._id,
      email: initialData.email,
    } as any);
  };

  return (
    <form onSubmit={handleSendEmail}>
      <div className="flex flex-col gap-2 w-full">
        <label htmlFor="email" className="text-sm">
          Confirm Email
        </label>
        <input
          type="email"
          id="email"
          value={initialData.email}
          disabled
          placeholder="Email"
          className="w-full p-2 border border-greyFifty rounded-md bg-greyTen"
        />

        <BtnPrimary
          type="submit"
          disabled={isSending}
          className="self-end mt-2"
        >
          {isSending ? (
            <div className="flex items-center gap-2">
              <span className="ml-2">Sending</span>
              <LoaderCircle size={16} className="animate-spin" />
            </div>
          ) : (
            'Send Email'
          )}
        </BtnPrimary>
      </div>
    </form>
  );
};

export default AgentOnboard;
